import React from "react";
import styled from "styled-components";
import { Modal } from "antd";
import LoadFromTemplate from "components/job/index/startJobStep/loadFromTemplate";
import ManageTodoListWithTemplate from "components/job/index/startJobStep/manageTodoList/withTemplate";
import ManageDatelineWithTemplate from "components/job/index/startJobStep/manageDateline/withTemplate";

const LoadFromTemplateModal = (props) => {
  // Component Props
  const { todo, dateline, visible, onCancel, title } = props;

  // Component State
  const [selectedTemplateId, setSelectedTemplateId] = React.useState(null);
  const [doneCreate, setDoneCreate] = React.useState(false);

  // Component Function
  const handleSelectTemplate = (templateId) => {
    setSelectedTemplateId(templateId);
  };

  React.useEffect(() => {
    if (doneCreate) {
      onCancel();
    }
  }, [doneCreate]);

  return (
    <StyledModal
      title={title}
      style={{ top: 20 }}
      visible={visible}
      onCancel={onCancel}
      width={1000}
      footer={null}
      header={null}
    >
      {!selectedTemplateId ? (
        <>
          {todo && (
            <LoadFromTemplate
              todo
              handleSelectTemplate={handleSelectTemplate}
            />
          )}
          {dateline && (
            <LoadFromTemplate
              dateline
              handleSelectTemplate={handleSelectTemplate}
            />
          )}
        </>
      ) : (
        <>
          {todo && (
            <ManageTodoListWithTemplate
              todoTemplateId={selectedTemplateId}
              setDoneCreate={setDoneCreate}
            />
          )}
          {dateline && (
            <ManageDatelineWithTemplate
              datelineTemplateId={selectedTemplateId}
              setDoneCreate={setDoneCreate}
            />
          )}
        </>
      )}
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .ant-modal-body {
    padding-top: ${(props) => props.theme.spacing[2]};
    padding-bottom: ${(props) => props.theme.spacing[2]};
    padding-left: ${(props) => props.theme.spacing[2]};
    padding-right: ${(props) => props.theme.spacing[2]};
  }
`;

export default LoadFromTemplateModal;
